export default function isInteger(value) {
  return /^\d+$/.test(value);
}